import { useMantineTheme } from "@mantine/core";
import { useState } from "react";
import { getBreakpoint } from "@/utils/mantine";
import HydratedMediaQuery from "@/utils/hydratedMediaQuery";
import { Section } from "@/components/common/section/Section";
import styles from "./CarrouselList.module.scss";
import { Carrousel, CarrouselProps } from "./carrousel/Carrousel";
import { CarrouselSelectorMobile } from "./CarrouselSelectorMobile/CarrouselSelectorMobile";
import { CarrouselSelectorDesktop } from "./CarrouselSelectorDesktop/CarrouselSelectorDesktop";

export type CarrouselListProps = {
  title: string;
  carrousel: CarrouselProps[];
};

export const CarrouselList = ({ title, carrousel }: CarrouselListProps) => {
  const theme = useMantineTheme();
  const isTabletOrDesktop = HydratedMediaQuery(
    getBreakpoint(theme.breakpoints.md)
  );
  const [carrouselSelectedIndex, setCarrouselSelectedIndex] =
    useState<number>(0);
  const [carrouselSelected, setCarrouselSelected] = useState<CarrouselProps>(
    carrousel[0]
  );

  return (
    <Section>
      <div className={styles.carrouselList}>
        <h2 className={styles.title}>{title}</h2>

        {!isTabletOrDesktop && (
          <CarrouselSelectorMobile
            carrousel={carrousel}
            setCarrouselSelected={setCarrouselSelected}
            carrouselSelectedIndex={carrouselSelectedIndex}
          />
        )}

        <Carrousel {...carrouselSelected} />
        {isTabletOrDesktop && (
          <CarrouselSelectorDesktop
            carrousel={carrousel}
            carrouselSelected={carrouselSelected}
            carrouselSelectedIndex={carrouselSelectedIndex}
            setCarrouselSelected={setCarrouselSelected}
            setCarrouselSelectedIndex={setCarrouselSelectedIndex}
          />
        )}
      </div>
    </Section>
  );
};
